import React, { useEffect, useContext, useState } from 'react';

//bs
import { Outlet, useLocation } from 'react-router-dom';

//context
import { UserContext } from 'context/UserContext';
import { showGlobalAlert } from 'context/AlertContext';

//cookies
import CookieConsent from 'react-cookie-consent';
import ReactGA from 'react-ga4';

//comps
import LoadingLayer from './loaders/LoadingLayer';
import Navigation from './Navigation';
import LoginPage from 'pages/LoginPage';

//api
import * as mainApi from 'api/mainApi';

const Layout = () => {
	const location = useLocation();

	ReactGA.initialize('G-JPR563LWS9');

	useEffect(() => {
		if (location.state?.scrollTarget) {
			setTimeout(() => {
				const el = document.getElementById(location.state.scrollTarget);
				if (el) {
					const topOffset =
						el.getBoundingClientRect().top +
						window.pageYOffset -
						(location.state.offset || 0);
					window.scrollTo({ top: topOffset, behavior: 'smooth' });
				}
			}, 200);
			return;
		}
		window.scrollTo({ top: 0, behavior: 'smooth' });
		ReactGA.send({ hitType: 'pageview', page: location.pathname });
	}, [location]);

	useEffect(() => {
		const handleScrollToSection = (e) => {
			const { path, offset } = e.detail;
			const el = document.getElementById(path);
			if (el) {
				const topOffset =
					el.getBoundingClientRect().top + window.pageYOffset - (offset || 0);
				window.scrollTo({ top: topOffset, behavior: 'smooth' });
			}
		};

		window.addEventListener('scrollToSection', handleScrollToSection);

		return () => {
			window.removeEventListener('scrollToSection', handleScrollToSection);
		};
	}, []);

	const { userLogged, setUserData } = useContext(UserContext);
	const [isLoading, setIsLoading] = useState(true);
	const [firstLoginCod, setFirstLoginCod] = useState(null);

	useEffect(() => {
		const checkLogin = async () => {
			setIsLoading(true);
			const data = await mainApi.checkUserLogin();
			setUserData(data.succeded ? data.userData : null);
			setIsLoading(false);
		};

		checkLogin();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//----------------------------

	const handleUserLogin = async (formData) => {
		setIsLoading(true);
		const data = await mainApi.userLogin(formData);
		if (data && data.succeded) {
			if (data.firstLogin) {
				setFirstLoginCod(formData.cod_empleado);
			} else {
				setUserData(data.userData);
			}
		} else {
			showGlobalAlert(
				'¡Ups!',
				data.message || 'Inténtalo de nuevo en unos minutos.',
			);
		}
		setIsLoading(false);
	};

	const handleCompleteFirstLogin = async (formData) => {
		setIsLoading(true);
		const data = await mainApi.completeFirstLogin({
			...formData,
			cod_empleado: firstLoginCod,
		});
		if (data && data.succeded) {
			setFirstLoginCod(null);
			setUserData(data.userData);
		} else {
			showGlobalAlert(
				'¡Ups!',
				data.message || 'Inténtalo de nuevo en unos minutos.',
			);
		}
		setIsLoading(false);
	};

	//----------------------------

	return (
		<div className="main-layout">
			<LoadingLayer visible={isLoading} hideAll />
			<CookieConsent
				location="bottom"
				buttonText="Aceptar"
				style={{ background: 'rgba(0, 0, 0, 0.8)' }}
				buttonStyle={{
					color: '#041428',
					fontSize: '12px',
					background: '#DCB694',
				}}
				expires={150}
			>
				Utilizamos cookies de terceros para analizar y mejorar tu navegación. Si
				continuas navegando, consideramos que aceptas su uso. Puedes cambiar la
				configuración u obtener más información en nuestra política de cookies.
			</CookieConsent>
			{userLogged ? (
				<>
					<div className="main-navigation">
						<Navigation />
					</div>
					<div className="main-container">
						<Outlet />
					</div>
				</>
			) : (
				<LoginPage
					onLogin={handleUserLogin}
					firstLoginCod={firstLoginCod}
					onCompleteFirstLogin={handleCompleteFirstLogin}
				/>
			)}
		</div>
	);
};

export default Layout;
